<ng-container *ngIf="!errorOccured; else modifiable">
	<div>
		<span translate>
			guarantee.draft.saved.successfully
		</span>
	</div>
	<div class="draft-follow-up">
		<span class="draft-follow-up-text" translate>
			guarantee.draft.edit
		</span>
	</div>
</ng-container>
<ng-template #modifiable>
	<div>
		<span class="guarantee-submit-error-text" translate>
			guarantee.save.failed
		</span>
	</div>
	<div class="guarantee-submit-error">
		<span class="guarantee-submit-error-text" translate>
			guarantee.save.failed.message
		</span>
	</div>
</ng-template>